import React, { useState }  from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import  api from './api';
import axios from "axios";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ViewIcon from '@material-ui/icons/Visibility';
import Button from "@material-ui/core/Button";

class HansaMedia extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {files:[], open: false}
    }
    
    async componentDidMount() {
        var id = this.props.id
        var model = this.props.model
    }
    
    getFiles = async () => {
		const token = localStorage.getItem('userToken')
	    var formData = new FormData();
	    formData.set("hansa_code", this.props.hansa_code);
	    formData.set("model", this.props.model);

		return await axios
	     .post(api.hansa_media().index(), formData,{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var files = res.data
	      		this.setState({files: files})
	      })
	      .catch(err =>{console.log(err)
	      })
    }


    handleDownload = async (name, id) => {
		const token = localStorage.getItem('userToken')
	    var formData = new FormData();
	    formData.set("hansa_code", id);

		return await axios
	     .post(api.hansa_media_download, formData, { headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
            var contentType = res.headers["content-type"]            
            var blob = new Blob([res.data], {type: contentType})
            var objectUrl = URL.createObjectURL(blob);
            window.open(objectUrl);
        })
	      .catch(err =>{console.log(err)
	      })
    }
    
    render() {
        const files = this.state.files
        return (
            <React.Fragment>
            <Button onClick={(e) => (this.getFiles())}><ViewIcon fontSize="small"/> Ver adjuntos Hansa</Button> 
            {(files)?(
                <Table aria-label="simple table">
                    <TableHead>
                    <TableRow>
                        <TableCell>Nombre del archivo</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {files.map((val,idx) => (
                        <TableRow key={val.id}>
                        <TableCell>{val.FileName}</TableCell>
                        <TableCell>
                            <ArrowDownwardIcon onClick={(e) => (window.open(api.hansa_media().download(val.SerNr, this.props.model), '_blank'))}/>Descargar
                        </TableCell>
                        </TableRow>
                    ))}
                    {(files.length === 0)
                    ?
                        <TableRow>
                        <TableCell>No hay archivos adjuntos</TableCell>
                        <TableCell>&nbsp;</TableCell>
                        </TableRow>
                    :
                        ''
                    }
                    </TableBody>
                </Table>
                )
            :
                ''
            }

            </React.Fragment>  
            )
        }
    }
    
    export default HansaMedia;
    